export var AttachmentManagerTableHeaderEnum;
(function (AttachmentManagerTableHeaderEnum) {
    AttachmentManagerTableHeaderEnum["id"] = "id";
    AttachmentManagerTableHeaderEnum["description"] = "Description";
    AttachmentManagerTableHeaderEnum["fileName"] = "File name";
    AttachmentManagerTableHeaderEnum["attachmentType"] = "Type";
    AttachmentManagerTableHeaderEnum["date"] = "Date";
    AttachmentManagerTableHeaderEnum["link"] = "Link";
    AttachmentManagerTableHeaderEnum["revision"] = "Revision";
})(AttachmentManagerTableHeaderEnum || (AttachmentManagerTableHeaderEnum = {}));
export const AttachmentManagerTableHeaderLookup = new Map([
    [AttachmentManagerTableHeaderEnum.fileName, "fileName"],
    [AttachmentManagerTableHeaderEnum.attachmentType, "attachmentType"],
    [AttachmentManagerTableHeaderEnum.date, "date"],
    [AttachmentManagerTableHeaderEnum.description, "description"],
    [AttachmentManagerTableHeaderEnum.revision, "revision"],
]);
